import { render, staticRenderFns } from "./staticsManage.vue?vue&type=template&id=eabbb070&scoped=true"
import script from "./staticsManage.vue?vue&type=script&lang=js"
export * from "./staticsManage.vue?vue&type=script&lang=js"
import style0 from "./staticsManage.vue?vue&type=style&index=0&id=eabbb070&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eabbb070",
  null
  
)

export default component.exports